import { useEffect, useState } from "react";
import {
  Cpu,
  HardDriveDownload,
  Info,
  Key,
  Network,
  Power,
  Router,
  Settings2,
} from "lucide-react";

import { useConfig } from "../../context/configContext";
import DeviceSetup from "../DeviceSetup";
import ChargerProvisioning from "../DeviceSetup/ChargerProvisioning";
import "./index.css";

const FirmwareUpdate = () => {
  const [animate, setAnimate] = useState(true);
  const [activeTab, setActiveTab] = useState(
    () => localStorage.getItem("firmware_active_tab") || "info",
  );
  const { config } = useConfig();
  const [selectedDispenser, setSelectedDispenser] = useState("");

  useEffect(() => {
    if (config?.dispensers) {
      setSelectedDispenser("1");
    }
  }, [config]);

  const switchTab = (tab) => {
    setAnimate(false);

    setTimeout(() => {
      setActiveTab(tab);
      localStorage.setItem("firmware_active_tab", tab);
      setAnimate(true);
    }, 150);
  };

  const dispenserOptions = Array.from(
    { length: Number(config?.dispensers || 0) },
    (_, i) => i + 1,
  );

  return (
    <main className="device-page-shell">
      <section className="device-page-header">
        <div>
          <p>Device setup</p>
          <h1>Firmware and station provisioning</h1>
        </div>
        <div className="device-header-stats">
          <span>
            <Router size={17} />
            {config.station_id || "No station"}
          </span>
          <span>
            <Cpu size={17} />
            {Number(config?.dispensers || 0)} dispensers
          </span>
        </div>
      </section>

      <div className="device-tabs" role="tablist" aria-label="Device sections">
        <button
          type="button"
          className={activeTab === "info" ? "is-active" : ""}
          onClick={() => switchTab("info")}
        >
          <Info size={17} />
          Info
        </button>

        <button
          type="button"
          className={activeTab === "setup" ? "is-active" : ""}
          onClick={() => switchTab("setup")}
        >
          <Settings2 size={17} />
          Setup
        </button>

        <button
          type="button"
          className={activeTab === "provision" ? "is-active" : ""}
          onClick={() => switchTab("provision")}
        >
          <Key size={17} />
          Provisioning
        </button>
      </div>

      <section
        className={`device-tab-panel ${
          animate ? "is-visible" : "is-transitioning"
        }`}
      >
        {activeTab === "info" && (
          <div className="firmware-info-grid">
            <article className="firmware-control-panel">
              <div className="panel-heading">
                <div>
                  <p>Target</p>
                  <h2>Dispenser selection</h2>
                </div>
                <span>{selectedDispenser || "None"}</span>
              </div>

              <label className="ops-field">
                <span>Select Dispenser</span>
                <select
                  value={selectedDispenser}
                  onChange={(e) => setSelectedDispenser(e.target.value)}
                >
                  {dispenserOptions.length > 0 ? (
                    dispenserOptions.map((num) => (
                      <option key={num} value={num}>
                        Dispenser {num}
                      </option>
                    ))
                  ) : (
                    <option>No dispensers</option>
                  )}
                </select>
              </label>
            </article>

            <article className="firmware-action-card">
              <span>
                <HardDriveDownload size={22} />
              </span>
              <div>
                <h3>Firmware Version</h3>
                <p>Read active firmware from selected dispenser.</p>
              </div>
              <button type="button">Get</button>
              <button type="button" className="danger-action">
                <Power size={16} />
                Reboot
              </button>
            </article>

            <article className="firmware-action-card">
              <span>
                <Network size={22} />
              </span>
              <div>
                <h3>MQTT Version</h3>
                <p>Fetch communication stack version.</p>
              </div>
              <button type="button">Get</button>
            </article>

            <article className="firmware-action-card">
              <span>
                <Router size={22} />
              </span>
              <div>
                <h3>IP Address</h3>
                <p>Read the current gateway network address.</p>
              </div>
              <button type="button">Get</button>
            </article>
          </div>
        )}

        {activeTab === "setup" && <DeviceSetup />}
        {activeTab === "provision" && <ChargerProvisioning />}
      </section>
    </main>
  );
};

export default FirmwareUpdate;
